import { SentryAPI } from '@/api';
import { useHelpers } from './use-helpers';
import { useAuth } from './use-auth';

export const useSentry = () => {
  const { accountId, sentryConfig, environmentClient, environmentEnv } = useHelpers();
  const { userId, username } = useAuth();

  if (!SentryAPI.isReady()) {
    SentryAPI.makeInstance({
      dsn: sentryConfig.value.dsn,
      environment: sentryConfig.value.environment,
      env: environmentEnv.value,
      client: environmentClient.value,
      userId: userId.value,
      accountId: accountId.value,
      username: username.value,
      sampleRate: sentryConfig.value.sampleRate,
      tracesSampleRate: sentryConfig.value.tracesSampleRate,
    });
  }

  return {
    captureMessage: SentryAPI.captureMessage,
    captureException: SentryAPI.captureException,
    captureAPIError: SentryAPI.captureAPIError,
  };
};
